import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_ACCOUNT_OVERVIEW: 'FETCH_ACCOUNT_OVERVIEW'
}

export default {
  fetchAccountOverview: accountId => {
    return apiClient.get(`/account/${accountId}/overview`)
  }
}


// WEBPACK FOOTER //
// ./src/features/overview/api/index.js